(function () {
  'use strict';

  const { subEvents, PUB_SUB_EVENTS } = window.Universe;

  class QuantityInput {
    constructor(wrap) {
      if (!wrap) return;
      this.init(wrap);
    }

    setup() {
      this.validate();

      this.quantityUpdateUnsubscriber = subEvents.subscribe(PUB_SUB_EVENTS.quantityUpdate, () => { this.validate(); });

      this.changeEvent = new Event('change', { bubbles: true });
      this._onInputChange = () => { this.onInputChange(); };
      this._onPrevQuantity = (event) => { this.onPrevQuantity(event); };
      this._onNextQuantity = (event) => { this.onNextQuantity(event); };
      this.DOM.input.addEventListener('change', this._onInputChange);
      this.DOM.prev.addEventListener('click', this._onPrevQuantity);
      this.DOM.next.addEventListener('click', this._onNextQuantity);
    }

    onInputChange() {
      this.validate();

      if (this.DOM.input.value < parseInt(this.DOM.input.dataset.min)) {
        this.DOM.input.value = this.DOM.input.dataset.min;
      }

      if (this.emitChange) {
        subEvents.publish(PUB_SUB_EVENTS.quantityUpdate, {
          data: {
            quantity: parseInt(this.DOM.input.value),
          },
        });
      }
    }

    onPrevQuantity(event) {
      event.preventDefault();
      const previousValue = this.DOM.input.value;

      if (parseInt(this.DOM.input.dataset.min) > parseInt(this.DOM.input.step) && this.DOM.input.value == 0) {
        this.DOM.input.value = this.DOM.input.dataset.min;
      } else {
        this.DOM.input.stepDown();
      }

      if (previousValue !== this.DOM.input.value) this.DOM.input.dispatchEvent(this.changeEvent);
    }

    onNextQuantity(event) {
      event.preventDefault();
      const previousValue = this.DOM.input.value;

      this.DOM.input.stepUp();

      if (previousValue !== this.DOM.input.value) this.DOM.input.dispatchEvent(this.changeEvent);
    }

    validate() {
      const quantityValue = parseInt(this.DOM.input.value);
      if (this.DOM.input.min) {
        this.DOM.prev.classList.toggle('is-disabled', parseInt(quantityValue) <= parseInt(this.DOM.input.dataset.min));
      }

      if (this.DOM.input.max) {
        const max = parseInt(this.DOM.input.max);
        this.DOM.next.classList.toggle('is-disabled', quantityValue >= max);
      }
    }

    getQuantity() {
      return parseInt(this.DOM.input.value);
    }

    destroy() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }

      this.DOM.input.removeEventListener('change', this._onInputChange);
      this.DOM.prev.removeEventListener('click', this._onPrevQuantity);
      this.DOM.next.removeEventListener('click', this._onNextQuantity);
    }

    init(wrap) {
      this.DOM = {};
      this.DOM.wrap = wrap;
      this.DOM.input = this.DOM.wrap.querySelector('.js-quantity-input');
      this.DOM.prev = this.DOM.wrap.querySelector('.js-quantity-prev');
      this.DOM.next = this.DOM.wrap.querySelector('.js-quantity-next');

      this.emitChange = this.DOM.input.dataset.emitChange !== undefined;
      this.quantityUpdateUnsubscriber = undefined;

      this.setup();
    }
  }

  window.Universe = window.Universe || {};
  window.Universe.QuantityInput = QuantityInput;
})();
